// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b2945d3b","164":"c2f1bbb0","172":"f2ae8ee5","352":"ec201b10","436":"10d48138","534":"5975404f","556":"7fe2f6ed","592":"5587c8af","924":"7cc56149"}[chunkId] + ".chunk.js";
};